import {getField, updateField} from 'vuex-map-fields';
import History from '@/commonFunction/baseTableModule'

let history_detail = new History('/ws/base_history/');

const state = {
    ...history_detail.state,
    columns: [
        {text: '', value: 'actions', sortable: false, divider: true, width: 40, brief: true,},
        // {text: 'Date', value: 'history_date', sortable: true, divider: true, width: 80, brief: true,},
        {text: 'Date', value: 'date_only', sortable: true, divider: true, width: 80, brief: true,},
        {text: 'Time', value: 'time_only', sortable: true, divider: true, width: 100, brief: true,},
        // {text: 'User', value: 'history_user__username', sortable: true, divider: true, width: 80, brief: true,},
        // {text: 'history_id', value: 'history_id', sortable: true, divider: true, width: 80, brief: true,},
        // {text: 'history_type', value: 'history_type', sortable: true, divider: true, width: 80, brief: true,},
        // {text: 'history_change_reason', value: 'history_change_reason', sortable: true, divider: true, width: 80, brief: true,},
        {text: 'Field', value: 'variable', sortable: false, divider: true, width: 80, brief: true,},
        // {text: 'old variable', value: 'old_variable', sortable: false, divider: true, width: 80, brief: true,},
        {text: 'New value', value: 'value', sortable: false, divider: true, brief: true,},
        {text: 'Old value', value: 'old_value', sortable: false, divider: true, brief: true,},
    ],
    options: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['history_id'],
                sortDesc: [true],
                multiSort: false,
                mustSort: true,
                descending: false,
            },
    month_left: new Date().toISOString().substr(0, 10),
    month_right: new Date().toISOString().substr(0, 10),
};
const getters = {
    ...history_detail.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...history_detail.actions,
};
const mutations = {
    ...history_detail.mutations,
};

export default {
    modules: {
        BaseHistoryDetail: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}